import {assert} from 'assert-ts';
import type {ChangeRequest} from 'api/types';
import type {MetadataEditState} from '../types';

export const assertChangeRequest = (
  taskId: string,
  state: Pick<MetadataEditState, 'metadata'>,
): ChangeRequest => {
  return assert(
    state.metadata?.changeRequests.find(cr => cr.id === taskId),
    `metadataEditReducer.assertChangeRequest: not found`,
    {taskId},
  );
};
